import { Box, Link, Stack, useTheme } from "@mui/material";
import { useCallback, useEffect, useState } from "react";

import useFetch from "../../../hooks/useFetch";
import { getAllSiteLoginContents } from "../../../services/siteLoginContent.service";
import { ISiteLoginContent } from "../../../models/site-login-content";

const LoginContents = () => {
  const theme = useTheme();

  const [contents, setContents] = useState<ISiteLoginContent[]>([]);

  const { sendRequest } = useFetch(getAllSiteLoginContents);

  const getContents = useCallback(async () => {
    const { data, success } = await sendRequest(undefined);
    if (data && success) {
      setContents(
        [...data].sort((a, b) => a.presentationOrder - b.presentationOrder),
      );
    }
  }, [sendRequest]);

  useEffect(() => {
    getContents();
  }, [getContents]);

  if (contents.length === 0) {
    return null;
  }

  return (
    <Stack spacing={1.5} mt={2} width="100%">
      {contents.map((content) => {
        const language = content.siteLoginContentLanguages?.[0];
        const documentText = language?.documentText;
        const linkLabel = language?.linkLabel;
        const linkUrl = content.linkUrl;

        if (!documentText && !linkUrl) {
          return null;
        }

        return (
          <Box key={content.id} sx={{ fontSize: theme.typography.body2 }}>
            {documentText && (
              <Box
                sx={{
                  "& p": { margin: 0 },
                  "& a": { color: theme.palette.primary.main },
                }}
                dangerouslySetInnerHTML={{
                  __html: documentText
                    .split("rgb(0, 0, 0)")
                    .join(
                      theme.palette.mode === "dark"
                        ? "rgb(255, 255, 255)"
                        : "rgb(0, 0, 0)",
                    ),
                }}
              />
            )}
            {linkUrl && (
              <Link
                href={linkUrl}
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                color={theme.palette.primary.main}
              >
                {linkLabel ? linkLabel : linkUrl}
              </Link>
            )}
          </Box>
        );
      })}
    </Stack>
  );
};

export default LoginContents;
